import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.t6p_1 = partyId;
        this.u6p_1 = pairingSetId;
        this.v6p_1 = date;
        this.w6p_1 = pairs;
        this.x6p_1 = discordMessageId;
        this.y6p_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.t6p_1.toString() + ', pairingSetId=' + this.u6p_1.toString() + ', date=' + this.v6p_1.toString() + ', pairs=' + toString(this.w6p_1) + ', discordMessageId=' + toString(this.x6p_1) + ', slackMessageId=' + toString(this.y6p_1) + ')';
      }
      hashCode() {
        var result = this.t6p_1.hashCode();
        result = imul(result, 31) + this.u6p_1.hashCode() | 0;
        result = imul(result, 31) + this.v6p_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.w6p_1) | 0;
        result = imul(result, 31) + hashCode(this.x6p_1) | 0;
        result = imul(result, 31) + hashCode(this.y6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.t6p_1.equals(other.t6p_1))
          return false;
        if (!this.u6p_1.equals(other.u6p_1))
          return false;
        if (!this.v6p_1.equals(other.v6p_1))
          return false;
        if (!equals(this.w6p_1, other.w6p_1))
          return false;
        if (!equals(this.x6p_1, other.x6p_1))
          return false;
        if (!equals(this.y6p_1, other.y6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
